import React from 'react';
import styles from "../styles/news-widget.module.scss";
import classNames from "classnames";
import {NewsWidgetItemViewModel} from "../models/news-widget.item.view-model";
import {Ellipsis} from "../../../core/components/misc/ellipsis/ellipsis";
import {BaseProps} from "../../../infrastructure/models/props/base-props";

export class NewsContentWidgetProps extends BaseProps {
  item: NewsWidgetItemViewModel
}

export const NewsWidgetItemContent = (({item}: NewsContentWidgetProps) => {
  const {title, source, publishRelativeTime, metaDataModel: {publishDate}} = item;

  return (
      <div itemProp="item" itemScope itemType="https://schema.org/NewsArticle" className={classNames(styles.news_content)}>
        <Ellipsis text={title} className={classNames(styles.news_header)} numOfMaxLines={3} itemProp="headline"/>
        <div itemProp="author" itemScope itemType="https://schema.org/Organization" className={classNames(styles.news_source_name)}>
          <Ellipsis itemProp="name">{source?.name}</Ellipsis>
        </div>
        <div itemProp="datePublished" content={publishDate} className={classNames(styles.news_publish_time)}>{publishRelativeTime}</div>
      </div>
  )
});
